import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import date from 'date-and-time';

import BotoneraBottom from '../Compartidos/BotoneraBottom';
import HeaderEjercicios from '../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../Escritorio/Instrucciones';
import useConfigAuth from '../../../Hooks/useConfigAuth';

import { finalizarEjercicioAction, setearEjercicioAction } from '../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../actions/almacenarEjercicioActions';

// css
import { ContainerFlex } from '../../Css/MetodosCSS/StyledLN2Todos';
import { Cuadrado} from '../../Css/MetodosCSS/StyledFonemica';
import { SilabasGrandes } from '../../Css/MetodosCSS/StyledLectoEscritura';
import {Flex} from '../../Css/MetodosCSS/StyledCCIntrasilabica';

const instrucciones = 'Vas a ver primero algunos objetos, luego unas letras y por último unos números, tenes que decirlos lo más rápido que puedas.” Esta actividad es la única que se considera el tiempo en que demora en responder';
const miniInstrucciones = '';

const SCR14 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [count, setCount] = useState(1);
    const [disable, setDisable] = useState(false);
    const [comparar, setComparar] = useState([]);
    const [indexes, setIndexes] = useState([]);
    const [resultado, setResultado] = useState([]);
    const [error, setError] = useState(0);
    const [correcto, setCorrecto] = useState(false);
    const [contarTiempo, setContarTiempo] = useState([]);
    const [ultimoTiempo, setUltimoTiempo] = useState(false);

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const minuscula = useSelector(state => state.configuracion.minuscula);

    const informacion = useSelector(state => state.informacion.info_DB);

    const resultadoBase = [
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0},
        {palabra_correcta:"", puntaje:0, ejemplo:0}
    ];

    const verifico = (e, nro) => {
        e.preventDefault();
        if(nro == 1){
            setError(error+1);
        } else {
            setCorrecto(true);
        }
        if(comparar.ejemplo == 1) {
            const newList = JSON.parse(JSON.stringify(resultado));
            newList[count-1].palabra_correcta = comparar.palabra_1;
            newList[count-1].puntaje = "0";
            newList[count-1].ejemplo = 1;
            setResultado(newList);
            if(count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                }, 100);
            } else {
                setUltimoTiempo(true);
                setTimeout(() => {
                    setDisable(false);
                    dispatch( finalizarEjercicioAction() )
                }, 100);
            }
            return
        }
        setDisable(true);
        const newList = JSON.parse(JSON.stringify(resultado));
        newList[count-1].palabra_correcta = comparar.palabra_1;
        let puntaje;
        if(nro == 1){
            puntaje = 0;
        } else if(nro == 2) {
            puntaje = 1;
        } else if(nro == 3){
            puntaje = 2;
        } else {
            puntaje = 3;
        }
        newList[count-1].puntaje = puntaje;
        newList[count-1].ejemplo = 0;
        setResultado(newList);
        if(count < indexes) {
            setTimeout(() => {
                setDisable(false);
                setCount(count + 1);
            }, 100);
        } else {
            setUltimoTiempo(true);
            setTimeout(() => {
                setDisable(false);
                dispatch( finalizarEjercicioAction() )
            }, 100);
        }
    }
    
    useEffect(() => {
        dispatch(setearEjercicioAction('SCR14') );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setComparar(informacion[count-1]);
        setIndexes(Object.keys(informacion).length);
    }, [count, informacion])
    
    useEffect(() => {
        setResultado(resultadoBase);
    }, [informacion])

    useEffect(() => {
        if(correcto) {
            return
        }
        if(error < 5) {
            return
        }
        setUltimoTiempo(true);
        setTimeout(() => {
            setDisable(false);
            dispatch( finalizarEjercicioAction() )
        }, 100);
    }, [error])

    useEffect(() => {
        if(iniciar === false && count === indexes){
            return;
        }else if(iniciar === false && count === 1){
            return;
        } else {
            const newList = JSON.parse(JSON.stringify(contarTiempo));
            newList.push(new Date());
            setContarTiempo(newList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iniciar,count, ultimoTiempo]);

    useEffect(() => {
         if(finalizar){
            const tiempo = JSON.parse(JSON.stringify(contarTiempo));
            const conseguirTiempos = (a) => {
                const t = [];
                for (let i = 0; i < a.length - 1; i++){
                    const despues = new Date(a[i+1]);
                    const antes = new Date(a[i])
                    const segundos = Math.round((date.subtract(despues, antes).toSeconds())*10)/10;
                    t.push(segundos);
                }
                return t
            }
            const tiempoFinal = conseguirTiempos(tiempo);

            const informacion = {
                config,
                payload: {
                    'screening': true,
                    'tiempo': tiempoFinal,
                    'ejercicio': "SCR14",
                    'resultado': resultado,
                    'id_paciente': id_paciente
                }
            }
            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} ayuImagen={false} />
            {iniciar
                ?
                <ContainerFlex display="flex" direction="column" height="100%" width="100%">
                    {comparar.ejemplo ? 
                    <Flex margin="1rem 0 0 2rem" style={{fontSize:"40px", fontFamily:"Nunito", fontWeight:"bold", justifyContent:"start" }}>
                        Ejemplo
                    </Flex>
                    : null
                    }
                    <ContainerFlex display="flex" align="center" justify="center" margin="auto" direction="column">
                        <ContainerFlex width="100%">
                            <SilabasGrandes style={{width:"100%"}} color="#646464" m='0px 0.5rem 0px 0px' $minMay={minuscula}>
                                {comparar.palabra_1}
                            </SilabasGrandes>
                        </ContainerFlex>
                    </ContainerFlex>

                    <ContainerFlex display="flex" justify="space-between" justifyself="end" margin="0 0 0.5rem 0">
                        <ContainerFlex>
                            <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                        </ContainerFlex>
                        <ContainerFlex display="flex">
                            <ContainerFlex display="flex" margin ="0 2rem 0 0">
                                <Cuadrado backgroundColor="#646464" margin="0 0.3rem 0 0"
                                disabled={disable}
                                onClick={(e) => verifico(e, 1)}
                                ></Cuadrado>
                                <Cuadrado backgroundColor="#FD5775" margin="0 0.3rem 0 0"
                                disabled={disable}
                                onClick={(e) => verifico(e, 2)}
                                ></Cuadrado>
                                <Cuadrado backgroundColor="#FDB62C" margin="0 0.3rem 0 0"
                                disabled={disable}
                                onClick={(e) => verifico(e, 3)}
                                ></Cuadrado>
                                <Cuadrado backgroundColor="#5DEBC9" margin="0 0.3rem 0 0"
                                disabled={disable}
                                onClick={(e) => verifico(e, 4)}
                                ></Cuadrado>
                            </ContainerFlex>
                        </ContainerFlex>
                    </ContainerFlex>
                </ContainerFlex>
                :
                <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}
 
export default SCR14;